import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "quiz-intro-drawer" };
const _hoisted_2 = { class: "quiz-intro-header" };
const _hoisted_3 = { class: "quiz-intro-content" };
const _hoisted_4 = { class: "quiz-intro-title" };
const _hoisted_5 = { class: "quiz-intro-subtitle" };
const _hoisted_6 = { class: "quiz-intro-image" };
const _hoisted_7 = ["src"];
const _hoisted_8 = { class: "quiz-intro-footer" };
const _hoisted_9 = { class: "quiz-intro-description" };
const _hoisted_10 = { class: "quiz-notifications" };
const _hoisted_11 = { class: "quiz-notifications-toggle" };
const _hoisted_12 = { class: "toggle-control" };
import { computed, useTemplateRef } from 'vue';
import DrawerPanel from './DrawerPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuizDrawerRulesPanel',
    props: {
        openHeight: {},
        quiz: {},
        customer: {}
    },
    emits: ["terms-click", "notifications-change"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const drawer = useTemplateRef('drawer');
        const heading = computed(() => {
            return props.quiz.advertisingHeader;
        });
        const headingDescription = computed(() => {
            return props.quiz.advertisingDescription;
        });
        const rulesDescription = computed(() => {
            return "Play for " + props.quiz.streakMeterMax + " days to get " + props.quiz.streakMeterMax + " bonus entries to the prize draw.";
        });
        const notificationsEnabled = computed(() => {
            return props.customer?.preferences?.quizNotifications ?? true;
        });
        function toggleNotifications() {
            emit('notifications-change', !notificationsEnabled.value);
        }
        function openDrawer() {
            drawer.value?.openDrawer();
        }
        function closeDrawer() {
            drawer.value?.closeDrawer();
        }
        __expose({ openDrawer, closeDrawer });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DrawerPanel, {
                ref_key: "drawer",
                ref: drawer,
                title: "",
                bottom: "-32px",
                blurBackground: true,
                closeBackground: false,
                openHeight: _ctx.openHeight,
                closedHeight: "0px",
                startOpened: false,
                close: true,
                divider: false,
                backgroundColor: "#FFFFFF",
                openBackgroundColor: "#F9F7F3;"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("h2", _hoisted_4, _toDisplayString(heading.value), 1),
                                _createElementVNode("p", _hoisted_5, _toDisplayString(headingDescription.value), 1)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("img", {
                                    src: _ctx.quiz.bgUrl,
                                    alt: "Quiz"
                                }, null, 8, _hoisted_7)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(rulesDescription.value), 1),
                            _createElementVNode("div", _hoisted_10, [
                                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "quiz-notifications-title" }, "Keep reminders on to keep up your streak!", -1)),
                                _createElementVNode("div", _hoisted_11, [
                                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "toggle-label" }, "Notifications:", -1)),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["toggle-text", { 'active': !notificationsEnabled.value }])
                                        }, "Off", 2),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["toggle-switch", { 'toggle-on': notificationsEnabled.value }]),
                                            onClick: toggleNotifications
                                        }, _cache[1] || (_cache[1] = [
                                            _createElementVNode("div", { class: "toggle-knob" }, null, -1)
                                        ]), 2),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["toggle-text", { 'active': notificationsEnabled.value }])
                                        }, "On", 2)
                                    ])
                                ])
                            ]),
                            _createElementVNode("a", {
                                href: "#",
                                class: "quiz-terms-link",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('terms-click')), ["prevent"]))
                            }, "Terms & Conditions")
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["openHeight"]));
        };
    }
});
